/*





Other Driver's Address (If known)
Other Driver's Contact Number (If known)

 */

export default class DriverInfo {
   constructor(
      {
         title = '',
         relationship = '',
         firstName = '',
         lastName = '',
         birthDate = '',
         employmentStatus = '',
         occupation = '',
         vehicleRegNumber = '',
         licenseType = '',
         licenseNumber = '',
         licenseDate = '',
         isBornInUK = '',
         yearObtainingUKResidency = '',
         /*dvlaReportedConditions = '',


         useOfOtherVehicles = '',
         unspentNonMotoringCriminalConviction = '',
         motorAccidentsOrClaimsIn5Years = '',
         penaltyPointsIn5Years = '',
         motorAccidentsList = [],*/
         address = '',
         contactNumber = '',
         hasChildren = '',
         numberOfChildren = '',
         motorAccidentsOrClaimsIn5Years = '',
         motorAccidentsList = [],
         
         motoringConvictionsIn5Years = '',
         motoringConvictionsList = [],
         
         wantToAddLicenseNumber = '',
         
      }
   ) {
      
      this.title = title;
      this.relationship = relationship;
      
      this.firstName = firstName;
      this.lastName = lastName;
      this.birthDate = birthDate;
      
      this.employmentStatus = employmentStatus;
      this.occupation = occupation;
      
      this.vehicleRegNumber = vehicleRegNumber;
      
      this.licenseType = licenseType;
      this.wantToAddLicenseNumber = wantToAddLicenseNumber;
      this.licenseNumber = licenseNumber;
      this.licenseDate = licenseDate;
      
      this.address = address;
      this.contactNumber = contactNumber;
      
      this.isBornInUK = isBornInUK;
      this.yearObtainingUKResidency = yearObtainingUKResidency;
      
      this.hasChildren = hasChildren;
      this.numberOfChildren = numberOfChildren;
      
      this.motorAccidentsOrClaimsIn5Years = motorAccidentsOrClaimsIn5Years;
      
      this.motorAccidentsList = motorAccidentsList;
      
      /**
       * Motoring Convictions ...
       */
      
      this.motoringConvictionsIn5Years = motoringConvictionsIn5Years;
      this.motoringConvictionsList = motoringConvictionsList;
   }
}